<template>
  <div class="top-carousel">
    <el-carousel :autoplay="autoplay" :initial-index="index">
      <el-carousel-item v-for="(item, index) in list" :key="index">
        <div class="w-full h-560 relative">
          <!-- <img :src="item.src" alt="" class="w-full h-full absolute left-0 top-0 z-10" > -->
          <div class="img-body w-full h-full absolute left-0 top-0 right-0 z-10">
            <img :src="item.src" alt="">
            <!-- <img src="../assets/images/test.jpg" alt=""> -->
          </div>
          <div class="max-width-1200 absolute top-0 left-0 right-0 bottom-0 z-30 h-full w-full flex flex-col justify-center">
            <div class="f42 font-shs-bold text-[#222] mb-18">{{ item.title }}</div>
            <div class="f20 text-[#333] mb-78 w-[60%]">{{ item.subtitle }}</div>
            <div class="btn btn-arrow" @click="clickService">
              <span class="pl-15 f18">商务咨询</span>
              <img class="ml-5" src="../assets/images/arrow_right2.png" alt="">
            </div>
          </div>
        </div>
      </el-carousel-item>
      <img src="../assets/images/banner1@2x.png" alt="img" class="carouselImg"/>
    </el-carousel>
  </div>
</template>

<script>
export default {
  name: "TopCarousel",
  props: {
    list: {
      type: Array,
      default: () => []
    },
    index: {
      type: Number,
      default: () => 0
    },
    autoplay: {
      type: Boolean,
      default: () => false
    }
  },
  methods: {
    clickService() {
      window.open('https://work.weixin.qq.com/kfid/kfc22af7e7b50d30b9b', '_blank')
    }
  },
};
</script>
<style lang="scss" scoped>
// ::v-deep .el-carousel__container {
//   height: 560px;
// }
// ::v-deep .el-carousel {
//   width: 100%;
// }
.top-carousel {
  text-align: left;
}
.img-body {
  // background: url('../assets/images/top_carousel_background.png') 100% no-repeat;
  // background-size: cover;
  // background-image: linear-gradient(to right, #f0f6fd, #e7f0fc);
  background: #e0ebfa;
  display: flex;
  justify-content: center;
}
.img-body img {
  display: block; /* 移除图片下面的默认空白行 */
  height: 100%; /* 设置图片高度等于容器高度，以保持比例 */
  object-fit: cover; /* 保持图片原始比例，可能的部分区域不会显示 */
  max-width: none; /* 允许图片宽度超出容器 */
  margin: 0 auto;
}
//轮播图
::v-deep .el-carousel {
    width: 100%;

    .el-carousel__container {
      height: 560px;
    }

    img {
      height: 100%;
      display: block;
      margin: auto;
    }

    .carouselImg {
      opacity: 0;
    }

    .el-carousel__indicators--horizontal {
      background: #00000000;
      left: 50%;
      bottom: 8%;
      transform: translateX(-600px);
    }
    .el-carousel__indicator {
      button {
        background: rgba(4, 95, 178, 0.2);
      }
    }
    .is-active {
      button {
        background: #045FB2;
      }
    }
  }
// .btn {
//   width: 154px;
//   height: 48px;
//   background: linear-gradient(28deg, #0093E9 0%, #80D0C7 100%);
//   border-radius: 4px 4px 4px 4px;
//   cursor: pointer;
//   line-height: 48px;
//   text-align: center;
//   font-size: 20px;
//   color: #fff;
//   margin: 38px 0px;
// }
</style>